
module.exports = {
  getYears: () => {
    let startYear = new Date().getFullYear();
    const endYear = 1900;
    const years = [];

    while (endYear <= startYear) {
      /* eslint-disable no-plusplus */
      years.push(startYear--);
      /* eslint-enable no-plusplus */
    }

    return years;
  },
  getMonths: () => [
    '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12',
  ],
  getDays: () => {
    let startDate = 1;
    const endDate = 31;
    const days = [];

    while (startDate <= endDate) {
      /* eslint-disable no-plusplus */
      days.push(startDate++);
      /* eslint-enable no-plusplus */
    }

    return days;
  },
};
